export enum EKeywordsReportTableFilters {
    OPPORTUNITIES = "opportunities",
    ORGANIC_CANNIBALIZATION = "organicCannibalization",
    PAID_CANNIBALIZATION = "paidCannibalization",
    TRAFFIC_DRIVERS = "trafficDrivers",
    TARGET_URL_MIS_RANK = "targetUrlMisRank",
    DROPPED = "dropped",
    COMPETITOR_WINNING = "competitorWinning",
}
